import { MenuItem } from '@chakra-ui/react';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
// import { CircleIcon, SquareIcon, VercelLogoIcon } from '@radix-ui/react-icons';
import { CircleIcon } from '@sketchnote/icons';
import * as React from 'react';
import {
  ColorStyle,
  fills,
  TDSnapshot,
  TDToolType,
  Theme,
  ToolButton,
  useTldrawApp,
} from 'sn-wb-tldraw';
import { Utils } from 'sn-wb-tldraw-core';

const currentStyleSelector = (s: TDSnapshot) => s.appState.currentStyle;

const canvasLight = '#fafafa';

const canvasDark = '#343d45';

export const colors = {
  [ColorStyle.Blue]: '#254DDA',
  [ColorStyle.Green]: '#3DD456',
  [ColorStyle.Red]: '#F87463',
  [ColorStyle.Yellow]: '#FFDA47',
  [ColorStyle.Pink]: '#FF4A7B',
  [ColorStyle.Violet]: '#E4C0FF',
  [ColorStyle.Orange]: '#FF9700',
};

export const strokes: Record<Theme, Record<string, string>> = {
  light: {
    [ColorStyle.Black]: '#00000',
    ...colors,
  },
  dark: {
    ...(Object.fromEntries(
      Object.entries(colors).map(([k, v]) => [k, Utils.lerpColor(v, canvasDark, 0.1)])
    ) as Record<ColorStyle, string>),
    [ColorStyle.White]: '#cecece',
    [ColorStyle.Black]: '#cecece',
  },
};

const statusSelector = (s: TDSnapshot) => s.appState.status;

enum Status {
  SpacePanning = 'spacePanning',
}

export const ColorMenu = React.memo(function ColorSelector() {
  const app = useTldrawApp();

  const status = app.useStore(statusSelector);
  const currentStyle = app.useStore(currentStyleSelector);
  const [displayedStyle, setDisplayedStyle] = React.useState(currentStyle);

  return (
    <div className="flex justify-center items-center flex-col gap-2 smallScreen:gap-0 py-5 smallScreen:py-0">
      {Object.keys(strokes.light).map((style: string, i) => (
        <div
          key={style}
          className="h-27 w-27 flex justify-center items-center transform smallScreen:scale-70 smallScreen:hover:scale-90 hover:scale-110 duration-75 ease-in-out "
        >
          <MenuItem style={{ justifyContent: 'center' }}>
            <div
              // kbd={(4 + i).toString()}
              className="flex justify-center items-center"
              onClick={() => app.style({ color: style as ColorStyle })}
            >
              <CircleIcon
                fill={colors[style]}
                wrapperClass="flex cursor-pointer justify-center items-center py-3 smallScreen:py-1"
              />
            </div>
          </MenuItem>
        </div>
      ))}
    </div>
  );
});
